// effects/products.effects.ts
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, tap } from 'rxjs/operators'; // Import operators correctly
import { of } from 'rxjs';



import { Store } from '@ngrx/store';
import { ApiService } from 'src/app/shared/services/api.service';
import { ApplyTemplateToProjectAction, ProjectContentActions, ProjectContentItemCreateActions } from './content.actions';
import { OutlineItem, ProjectItem } from 'src/app/shared/models/base.models';


@Injectable()
export class ProjectContentEffects {

  constructor(
    private actions$: Actions,
    private api: ApiService,
    private store: Store
  ) {

  }


  loadOutline = createEffect(() =>
  this.actions$.pipe(
    ofType(ProjectContentActions.load), // Listen for the loadProducts action
    mergeMap(({projectId}) =>
      this.api.getProjectContentById(projectId).pipe( // Use pipe method correctly within mergeMap
        map((response: {contents: OutlineItem[]}) => ProjectContentActions.loadSuccess({ contents: response.contents || [] })),
        catchError((error) => of(ProjectContentActions.loadFailure({ error }))
      )
    )
  )
));


createOutlineItem = createEffect(() =>
  this.actions$.pipe(
    ofType(ProjectContentItemCreateActions.create), // Listen for the loadProducts action
    mergeMap(({projectId, payload}) =>
      this.api.createProjectContent(projectId, payload).pipe( // Use pipe method correctly within mergeMap
        map((response: {content: OutlineItem}) => ProjectContentItemCreateActions.success({ item: response.content })),
        catchError((error) => of(ProjectContentItemCreateActions.failure({ error }))
      )
    )
  )
));


applyOutlineTemplate = createEffect(() =>
  this.actions$.pipe(
    ofType(ApplyTemplateToProjectAction.apply), // Listen for the loadProducts action
    mergeMap(({projectId, payload}) =>
      this.api.applyProjectContentTemplate(projectId, payload).pipe( // Use pipe method correctly within mergeMap
        map((response: {contents: OutlineItem[]}) => ApplyTemplateToProjectAction.success({ contents: response.contents })),
        catchError((error) => of(ApplyTemplateToProjectAction.failure({ error }))
      )
    )
  )
));

}
